import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import MobileBookBar from "@/components/MobileBookBar";
import Home from "@/pages/Home";
import Photography from "@/pages/Photography";
import Portfolio from "@/pages/Portfolio";
import CategoryGallery from "@/pages/CategoryGallery";
import RealEstate from "@/pages/RealEstate";
import Learn from "@/pages/Learn";
import Workshops from "@/pages/Workshops";

import GiftCards from "@/pages/GiftCards";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Book from "@/pages/Book";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Pricing from "@/pages/Pricing";
import Portal from "@/pages/Portal";
import ClientPage from "@/pages/admin/ClientPage";
import Admin from "@/pages/admin/Admin";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function SiteFrame() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="grain min-h-screen bg-[#F9F9F8] text-[#1A1A1A]">
      <ScrollToTop />
      {!isAdmin && !pathname.startsWith("/portal") && <Nav />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/photography" element={<Photography />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/photography/:slug" element={<CategoryGallery />} />
        <Route path="/real-estate" element={<RealEstate />} />
        <Route path="/learn" element={<Learn />} />
        <Route path="/workshops" element={<Workshops />} />
        <Route path="/gift-cards" element={<GiftCards />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/book" element={<Book />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/portal/:token" element={<Portal />} />
        <Route path="/admin/client/:id" element={<ClientPage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!isAdmin && !pathname.startsWith("/portal") && <Footer />}
      <MobileBookBar />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <BrowserRouter>
      <SiteFrame />
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
